module.exports = __webpack_public_path__ + "static/media/go_button.94bb1161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameMailDelivery/go_button.png
// module id = 2497
// module chunks = 0